module.exports = __webpack_public_path__ + "img/search.ab235663.svg";